import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { GlobalDataProvider } from "globalProviders/GlobalDataProvider";
import { queryClient } from "index";
import React from "react";
import { QueryClientProvider } from "react-query";
import { CustomThemeProvider } from "./CustomThemeProvider";
import { AuthProvider } from "./AuthProvider";
import en from "intl/en";
import { getAuthInitialState } from "stores/authStore";
import { KnowfullyLocalizationProvider } from "@knowfully/ui.common";

type AppDependenciesProviderProps = {
  children: React.ReactNode;
};

export const AppDependenciesProvider = ({
  children,
}: AppDependenciesProviderProps) => {
  const organizationId = getAuthInitialState().organizationId;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <QueryClientProvider client={queryClient}>
        <KnowfullyLocalizationProvider
          locale="en"
          organizationId={organizationId}
          defaultMessages={en}
        >
          <GlobalDataProvider>
            <AuthProvider>
              <CustomThemeProvider>{children}</CustomThemeProvider>
            </AuthProvider>
          </GlobalDataProvider>
        </KnowfullyLocalizationProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  );
};
